import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../components/LanguageProvider/LanguageProvider ";
import { GetLocalStorage } from "../../../Utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { Message } from "../../../components/message";
import { BsChevronLeft } from "react-icons/bs";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";

const OldApplicationView = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const token = GetLocalStorage("userInfo");
  const [appData, setAppData] = useState(null);
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      if (location?.state && location?.state?.data) {
        setAppData(location?.state?.data);
      }
    }
  }, [location?.state]);

  const formatApplicationData = (category) => {
    return category
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <>
      <AdminDashboard>
        <div className="aod-outer">
          {apiMessage && (
            <Message
              apiMessage={apiMessage}
              setApiMessage={setApiMessage}
            ></Message>
          )}
          <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
            <div>
              <HomeIcon />
              <b onClick={() => navigate("/admin/")}>Home / </b>
              <span>Old Application Details</span>
            </div>
          </div>
          <div className="aod-top user-aod-top mb-3">
            <div className=" text-center mb-2 adm-head">
              <button
                onClick={() => {
                  navigate("/admin/old-applications");
                }}
              >
                <BsChevronLeft /> Back
              </button>
            </div>
          </div>
          {appData ? (
            <div className="mb-4">
              <div className="col-md-12">
                <div className="data-wrapper">
                  <div>
                    <div className="data-wrapper-heading-block d-flex justify-content-between align-items-center" style={{ 'background' : "#00aeef" }}>
                      <div className="data-wrapper-heading">
                        <h5 className="mb-0">Old Application</h5>
                      </div>
                    </div>
                    <div className="data-item-details">
                      <div className="row">
                        {Object.keys(appData).map((key) => {
                          const fieldValue = appData[key] || "--"; // Default to '--' if no value
                          if (fieldValue === "--") {
                            return null; 
                          }
                          return (
                            <div className="col-md-6" key={key}>
                              <div className="preview-data py-2 px-3 d-flex justify-content-between align-items-center">
                                <div className="preview-left-heading">
                                  <h6 className="fw-bold mb-0">
                                    {formatApplicationData(key)}
                                  </h6>
                                </div>
                                <div className="preview-right-heading w-75 text-end">
                                  <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                      __html: fieldValue,
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-12"></div>
          )}
        </div>
      </AdminDashboard>
    </>
  );
};

export default OldApplicationView;
